/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('riskviewer', {
      restrict: 'E',
      bindings: {
        risk: '='
      },
      template: `
           <i class="fa fa-glass" ng-class="vm.risk.alcohol ? 'text-danger' : 'text-muted'" uib-tooltip="Alkohol: {{vm.risk.alcoholdetails}}"></i>
           <i class="fa fa-magic" ng-class="vm.risk.nicotin ? 'text-danger' : 'text-muted'" uib-tooltip="Nikotin: {{vm.risk.nicotindetails}}"></i>
           <i class="fa fa-warning" ng-class="vm.risk.otherb ? 'text-danger' : 'text-muted'" uib-tooltip="{{vm.risk.other}}"></i>
      `,
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;

        }] // controller
    }); // component

// klammerfriedhof
}());